import { GenerateSolutionResponse as ProtoGenerateSolutionResponse } from "@opstel/gen/knop/ui/v1/api/hip_pb";
import { z } from "zod/v3";
import { PlainMessage } from "@bufbuild/protobuf";
import { ZodOutputFor, createSchema } from "../zod-utils";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";

export interface GenerateSolutionResponse {
  status: ResponseStatus;
  failureDescription: string;
  toHipConversionErrors: string[];
}

export const generateSolutionResponseSchema = createSchema<
  GenerateSolutionResponse,
  PlainMessage<ProtoGenerateSolutionResponse>
>({
  status: responseStatusSchema,
  failureDescription: z.string(),
  toHipConversionErrors: z.array(z.string()),
}) satisfies ZodOutputFor<GenerateSolutionResponse>;

export function parseGenerateSolutionResponse(
  proto: PlainMessage<ProtoGenerateSolutionResponse>,
): GenerateSolutionResponse {
  return generateSolutionResponseSchema.parse(proto);
}
